// Custom scripts
import Prepaidcard from "./prepaidcard";
import PopupZaloguj from "../koszyk/popup-zaloguj";

(() => {
    if (typeof $ === "undefined") {
        throw new TypeError("... requires jQuery.");
    }

    $(document).ready(() => {
        const t = new Prepaidcard();
        const popupZaloguj = new PopupZaloguj();

        t.init();
        popupZaloguj.init();
    });
})();
